import { FC } from "react";
import { InteractiveContainer, PlainButton } from "@jugl-web/ui-kit";
import { getFileExtension, getFileName } from "../../utils";
import { ReactComponent as DocumentIcon } from "./assets/document.svg";
import { ReactComponent as DownloadArrowIcon } from "./assets/download-arrow.svg";

interface CommentFileListProps {
  attachments: string[];
  onAttachmentClick?: (url: string, allUrls: string[]) => void;
  onDownload?: (url: string) => void;
}

const FileThumbnail: FC<{ extension: string }> = ({ extension }) => (
  <div className="relative flex h-10 w-10 shrink-0 items-center justify-center">
    <DocumentIcon className="text-primary" />
    <div className="absolute inset-0 flex items-center justify-center">
      <span className="font-secondary text-[10px] font-medium text-white select-none">
        {extension.slice(0, 4)}
      </span>
    </div>
  </div>
);

export const CommentFileList: FC<CommentFileListProps> = ({
  attachments,
  onAttachmentClick,
  onDownload,
}) => (
  <div className="mt-2 flex flex-col gap-1">
    {attachments.map((url) => {
      const ext = getFileExtension(url);
      const name = getFileName(url);

      const Wrapper = onAttachmentClick ? InteractiveContainer : "div";

      return (
        <Wrapper
          key={url}
          className="flex items-center gap-2 rounded-lg px-1 py-1 transition-colors hover:bg-grey-100"
          onClick={
            onAttachmentClick
              ? () => onAttachmentClick(url, attachments)
              : undefined
          }
        >
          <FileThumbnail extension={ext} />
          <span className="min-w-0 flex-1 truncate text-sm font-medium text-dark">
            {name}
          </span>
          <PlainButton
            className="flex h-6 w-6 shrink-0 items-center justify-center overflow-hidden rounded-full bg-dark-500"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (onDownload) {
                onDownload(url);
                return;
              }
              window.open(url, "_blank");
            }}
          >
            <DownloadArrowIcon />
          </PlainButton>
        </Wrapper>
      );
    })}
  </div>
);
